/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skills_Skill_LevelInputs */

const en_tables_skills_skill_level = /** @type {(inputs: Tables_Skills_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill-Level`)
};

const de_tables_skills_skill_level = /** @type {(inputs: Tables_Skills_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill-Level`)
};

/**
* | output |
* | --- |
* | "Skill-Level" |
*
* @param {Tables_Skills_Skill_LevelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skills_skill_level = /** @type {((inputs?: Tables_Skills_Skill_LevelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skills_Skill_LevelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skills_skill_level(inputs)
	return de_tables_skills_skill_level(inputs)
});